import { render, staticRenderFns } from "./app-sidebar.vue?vue&type=template&id=a060c614&scoped=true"
import script from "./app-sidebar.vue?vue&type=script&lang=js"
export * from "./app-sidebar.vue?vue&type=script&lang=js"
import style0 from "./app-sidebar.vue?vue&type=style&index=0&id=a060c614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a060c614",
  null
  
)

export default component.exports